import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProduitService } from '../../services/produit.service';
import { Prof } from '../../models/personne.model';
import { GeneralContactForm, ServiceDemande } from '../../models/contactForm.model';
import { EtablissementService } from '../../services/etablissement.service';
import { Ville, Ecole } from '../../models/etablissement.model';
import { ContactFormService } from '../../services/contactForm.service';
import { BrochureService } from '../../services/brochure.service';
import { Brochure } from '../../models/brochure.model';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';

@Component({
    selector: 'contact-general',
    templateUrl: './contactGeneral.component.html',
    styleUrls: ['./contactGeneral.component.scss']
})
export class ContactGeneralComponent implements OnInit {

    isSendingForm = false;
    isLoadingBrochures = true;
    generalContactForm: GeneralContactForm = new GeneralContactForm();
    villes: Ville[];
    ecoles: Ecole[];
    error = '';
    selectedServices: string[] = new Array<string>();
    formAnswer: any = null;
    brochure: Brochure = new Brochure();

    constructor(
        private produitService: ProduitService,
        private route: ActivatedRoute,
        private etablissementService: EtablissementService,
        private contactFormService: ContactFormService,
        private brochureService: BrochureService,
        private titleService: Title,
        private metaTagService: Meta,
        @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    ngOnInit() {
        this.titleService.setTitle('Contact');
        this.metaTagService.updateTag({
            name: 'description',
            content: 'Demande de tout type d\'information supplémentaire au Centre de Formation du Languedoc.'
        });
        this.getBrochures();
    }


    verifNom(event) {
        const target = event.target || event.srcElement || event.currentTarget;
        const value = target.value;
        if ((value.length < 1) || (value.length > 20)) {
            this.surligne(target, true);
            return false;
        } else {
            this.surligne(target, false);
            return true;
        }
    }

    verifMail(event) {
        const target = event.target || event.srcElement || event.currentTarget;
        const value = target.value;
        const regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
        if (!regex.test(value)) {
            this.surligne(target, true);
            return false;
        } else {
            if ((value.length < 1) || (value.length > 40)) {
                this.surligne(target, true);
                return false;
            } else {
                this.surligne(target, false);
                return true;
            }
        }
    }

    verifTel(event) {
        const target = event.target || event.srcElement || event.currentTarget;
        const value = target.value;
        const regex = /^(0|\+33|0033)[1-9][0-9]{8}$/;
        if (!regex.test(value)) {
            this.surligne(target, true);
            return false;
        } else {
            if ((value.length < 10) || (value.length > 15)) {
                this.surligne(target, true);
                return false;
            } else {
                this.surligne(target, false);
                return true;
            }
        }
    }

    surligne(target, erreur) {
        if (isPlatformBrowser(this.platformId)) {
            const idAttr = target.attributes.id;
            const idValue = idAttr.nodeValue;
            if (erreur) {
                document.getElementById(idValue).style.backgroundColor = '#fba';
            } else {
                document.getElementById(idValue).style.backgroundColor = '';
            }
        }
    }

    verifForm() {
        this.error = '';
        if (!this.generalContactForm.identite || this.generalContactForm.identite === '') {
            this.error = 'Veuillez indiquer votre identité svp.';
            return;
        }
        if (!this.generalContactForm.message || this.generalContactForm.message === '') {
            this.error = 'Veuillez entrer un message svp.';
            return;
        }
        if (!this.generalContactForm.telephone || this.generalContactForm.telephone === '') {
            this.error = 'Veuillez entrer votre numéro de téléphone svp.';
            return;
        } else {
            const regex = /^(0|\+33|0033)[1-9][0-9]{8}$/;
            if (!regex.test(this.generalContactForm.telephone)) {
                this.error = 'Veuillez entrer un numéro de téléphone valide svp.';
                return;
            }
        }
        if (!this.generalContactForm.mail || this.generalContactForm.mail === '') {
            this.error = 'Veuillez entrer votre adresse mail svp.';
            return;
        } else {
            const regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
            if (!regex.test(this.generalContactForm.mail)) {
                this.error = 'Veuillez entrer une adresse mail valide svp.';
                return;
            }
        }

        // If we didn't get any error, then we send the form
        this.sendForm();
    }

    sendForm() {
        this.isSendingForm = true;
        this.contactFormService.sendGeneralForm(this.generalContactForm).subscribe(
            (res: any) => {
                this.formAnswer = res;
                this.isSendingForm = false;
            },
            (err) => {
                this.error = 'Une erreur est survenue lors de l\'envoi du formulaire. Veuillez vérifier les informations saisies svp.\n Si toutefois l\'erreur persiste, veuillez nous contacter svp.';
                console.log(err);
                this.isSendingForm = false;
            }
        );
    }

    getBrochures() {
        this.brochureService.getStageAndPrepa().subscribe(
          (res) => {
            this.brochure = res;
            this.isLoadingBrochures = false;
          },
          (err) => {
              console.log(err);
              this.isLoadingBrochures = false;
          }
        );
      }

}
